import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BarChart3, Settings, ArrowRightLeft, Library, PieChart, LayoutGrid, ShieldAlert } from "lucide-react";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/partner/portfoliomanagement/p", icon: BarChart3 },
  { label: "P Fund Holdings and Weightings", path: "/partner/portfoliomanagement/p/funds", icon: Settings },
  { label: "Holdings Sector Appropriating", path: "/partner/portfoliomanagement/p/sector-weightings", icon: PieChart },
  { label: "P Sector Weightings", path: "/partner/portfoliomanagement/p/p-sector-weightings", icon: LayoutGrid },
  { label: "Trade Log", path: "/partner/portfoliomanagement/p/trades", icon: ArrowRightLeft },
  { label: "Investable Universe", path: "/partner/portfoliomanagement/p/universe", icon: Library },
  { label: "Risk Analysis", path: "/partner/portfoliomanagement/p/risk", icon: ShieldAlert },
];

export default function BenchmarkLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen">
      {/* Sub-navigation */}
      <div className="border-b bg-muted/30 mt-6 pt-2">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-1 h-12 w-full overflow-x-auto">
            {NAV_ITEMS.map((item) => {
              const isActive = item.path === "/partner/portfoliomanagement/p"
                ? location.pathname === item.path
                : location.pathname === item.path || location.pathname.startsWith(item.path + "/");
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={cn(
                    "flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap",
                    isActive
                      ? "bg-primary text-primary-foreground font-medium"
                      : "text-muted-foreground hover:text-foreground hover:bg-muted"
                  )}
                >
                  <item.icon className="h-4 w-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Page content */}
      <div className="px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </div>
    </div>
  );
}
